export const REPORTING_LIBRARY_MAIN_HEADING = 'Reporting Library';
export const REPORTING_LIBRARY_SUB_HEADING =
	'Streamline data analysis and reporting with our powerful reporting library.';
export const REPORTING_ADD_REPORT_BUTTON_TEXT = 'Add Report';
export const REPORTING_SECTION_TITLE = 'Reports and Analytics';
export enum ReportingLibraryTabs {
	RECENTLY_VIEWED_TAB = 'Recently Viewed',
	FAVORITES_TAB = 'Favorites',
	REQUIREMENT_INVENTORY_TAB = 'Requirement Inventory',
	HORIZON_SCANNING_TAB = 'Horizon Scanning',
	PRCI_TAB = 'PRCI',
	MANAGEMENT_TAB = 'Management',
	BOARD_TAB = 'Board',
}

export enum ReportingDashboardType {
	PRCI = 'PRCI',
	REGULATION_INVENTORY = 'REGULATION-INVENTORY',
	HORIZON_SCANNING = 'HORIZON-SCAN',
	FAVORITE = 'FAVOURITE',
	RECENTLY_VIEWED = 'RECENTLY-VIEWED',
	MANAGEMENT = 'MANAGEMENT',
	BOARD = 'BOARD',
}

export enum ReportingLibraryScreenDimensions {
	SCREEN_WIDTH_1024 = 1024,
	SCREEN_WIDTH_1920 = 1920,
	SCREEN_WIDTH_1440 = 1440,
	SCREEN_WIDTH_2560 = 2560,
	SCREEN_HEIGHT_960 = 960,
	SCREEN_HEIGHT_1080 = 1080,
	SCREEN_HEIGHT_768 = 768,
	SCREEN_HEIGHT_920 = 920,
	SCREEN_HEIGHT_1600 = 1600,
	SCREEN_WIDTH_1280 = 1280,
	SCREEN_WIDTH_1536 = 1536,
	SCREEN_WIDTH_1792 = 1792,
	SCREEN_HEIGHT_720 = 720,
	SCREEN_HEIGHT_864 = 864,
	SCREEN_HEIGHT_1120 = 1120,
}
